export default "__VITE_ASSET__BBZOIGOh__"